import React, { useState, useEffect, useMemo } from 'react';
import api from '../../utils/api';
import Loader from '../../components/common/Loader';

const CategoryWiseReportPage = () => {
  const [loading, setLoading] = useState(true);
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        setLoading(true);
        const assetsRes = await api.getAssets({ limit: 1000 });
        if (assetsRes.success) setAssets(assetsRes.data || []);
      } catch (error) {
        console.error('Error loading category-wise report data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAssets();
  }, []);

  const rows = useMemo(() => {
    const map = new Map();

    assets.forEach((asset) => {
      const category = asset.category || 'Uncategorized';
      if (!map.has(category)) {
        map.set(category, {
          category,
          total: 0,
          available: 0,
          assigned: 0,
          issues: 0,
        });
      }
      const entry = map.get(category);
      entry.total += 1;
      if (asset.status === 'available') entry.available += 1;
      else if (asset.status === 'issue_reported') entry.issues += 1;
      else entry.assigned += 1;
    });

    return Array.from(map.values()).sort((a, b) => b.total - a.total);
  }, [assets]);

  if (loading && assets.length === 0) {
    return <Loader />;
  }

  return (
    <div className="category-wise-report-page" style={{ padding: '16px' }}>
      <div
        style={{
          background: 'white',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
          }}
        >
          <div style={{ fontSize: '14px', color: '#718096' }}>
            Distribution of assets grouped by category.
          </div>
          <div style={{ fontSize: '12px', color: '#a0aec0' }}>
            Total categories: {rows.length}
          </div>
        </div>

        {rows.length === 0 ? (
          <p style={{ fontSize: '13px', color: '#a0aec0', margin: 0 }}>No data available</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '13px',
                minWidth: '600px',
              }}
            >
              <thead>
                <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                  <th
                    style={{
                      textAlign: 'left',
                      padding: '8px 6px',
                      color: '#718096',
                      fontSize: '11px',
                    }}
                  >
                    Category
                  </th>
                  <th
                    style={{
                      textAlign: 'right',
                      padding: '8px 6px',
                      color: '#718096',
                      fontSize: '11px',
                    }}
                  >
                    Total Assets
                  </th>
                  <th
                    style={{
                      textAlign: 'right',
                      padding: '8px 6px',
                      color: '#718096',
                      fontSize: '11px',
                    }}
                  >
                    Available
                  </th>
                  <th
                    style={{
                      textAlign: 'right',
                      padding: '8px 6px',
                      color: '#718096',
                      fontSize: '11px',
                    }}
                  >
                    Assigned
                  </th>
                  <th
                    style={{
                      textAlign: 'right',
                      padding: '8px 6px',
                      color: '#718096',
                      fontSize: '11px',
                    }}
                  >
                    Issues
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.category} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '8px 6px', color: '#2d3748' }}>{row.category}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: '#2d3748' }}>
                      {row.total}
                    </td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: '#38a169' }}>
                      {row.available}
                    </td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: '#3182ce' }}>
                      {row.assigned}
                    </td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', color: '#e53e3e' }}>
                      {row.issues}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryWiseReportPage;

